/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const ENABLE_CLAIM = gql`
mutation EnableClaim($tokenId: String!, $tokenGroup: String!, $claimType: AssetClaimType!, $email: String, $voucherCode: String) {
  enableClaim(tokenId: $tokenId, tokenGroup: $tokenGroup, claimType: $claimType, email: $email, voucherCode: $voucherCode) {
    email
    voucherCode
    claimType
    exp
  }
}
`;
